<template>
	<v-layout row wrap>
		<v-flex sm10 offset-sm1 xs12>

			<h2 class="display-1">Contacto</h2>
			<v-alert color="warning"  :value="form_error">
				  <div v-html="form_message"></div>
			</v-alert>

			<v-alert  color="success" :value="form_success">
				  {{form_message}}
			</v-alert>

			<v-card v-if="!form_success" class="elevation-3 card-item">


				<v-form  v-model="valid" ref="form">
				    <v-text-field
				      label="Nombre"
				      v-model="nombre"
				      :rules="nombreRules"
				      required
					  class="mb-3"
				    ></v-text-field>
				    <v-text-field
				      label="E-mail"
				      v-model="email"
				      :rules="emailRules"
				      required
					  class="mb-3"
				    ></v-text-field>

					<v-text-field
				      label="Comentarios"
				      v-model="mensaje"
				      :rules="mensajeRules"
				      required
					  :counter="10"
					  multi-line
					  class="mb-3"

				    ></v-text-field>

			    <p class="text-xs-right"><v-btn @click="submit" :class="{ green: valid, white: !valid }">Enviar</v-btn></p>
			    <!-- v-btn @click="clear">clear</v-btn -->
			  </v-form>
		  </v-card>



		</v-flex>

	</v-layout>


</template>

<script>
  import axios from 'axios';
  export default {
    data () {
      return {
		form_error: false,
		form_success: false,
		form_message: '',
        valid: false,
        nombre: '',
        nombreRules: [
          (v) => !!v || 'El nombre es requerido',
          (v) => v && v.length > 2 || 'El nombre debe tener al menos 3 caracteres'
        ],
        email: '',
        emailRules: [
          (v) => !!v || 'el e-mail es requedido',
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'el email debe ser válido'
	    ],
		mensaje: "",
        mensajeRules: [
          (v) => !!v || 'El comentario es requerido',
          (v) => v && v.length >= 10 || 'El comentario debe tener al menos 10 caracteres'
        ],
		captcha: "123",
        captchaRules: [
          (v) => !!v || 'El código de seguridad es requerido'
        ],
      }
    },
    head: {
	   title: function () {
	      return {
	        	inner: this.empresa.description,
	       		complement: 'Contacto'
	    	}
	      
	    }
	},
    methods: {
      submit () {
        if (this.$refs.form.validate()) {
			this.form_error = false;
			var formData = {
				nombre: this.nombre,
				email: this.email,
				mensaje: this.mensaje,
				captcha: this.captcha,
				empresa: this.empresa.id
			}
			axios.post( this.$apiUrl + 'contact', formData ).then(response => {
					if(response.data.success){
						this.form_success = true
					}else{
						this.form_error = true
					}
					this.form_message = response.data.message;

            })
            .catch(e => {
		     if(error.body && error.body.message){
					this.form_message = error.body.message;
				}else{
					this.form_message = 'Datos Incorrectos';
				}

            	this.form_error = true
		    })

         // this.$refs.form.$el.submit()
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    },
    watch: {
        empresa: function(key){
        	this.$emit('updateHead')
        }
    },
    computed: {
	    empresa () {
	      return this.$store.getters.brand
	    }
	}
  }
</script>



// WEBPACK FOOTER //
// Contact.vue?735a0f71